<template>
  <div class="abilityTeam">
    <div class="teamDiv">
      <div class="abilityImage">
        <img src="../assets/images/picture_19.png" alt="">
        <div class="ideaText">
          <div class="fz32">壹心本部</div>
        </div>
      </div>
      <div class="compText">
        坐立于壹心保代嘉兴大本营，成立至今创造新单保费2925万，团队由传统保险精英与优秀外资团队组成，团队长具备丰富的经营管理经验，自主经营能力强，团队活动丰富、具有凝聚力。目前在册人力162人，在嘉兴保险市场打响了品牌。
      </div>
    </div>

    <div class="middle">
      <div class="middleItem">
        <div class="abilityImage">
          <img src="../assets/images/picture_20.png" alt="">
          <div class="ideaText">
            <div class="fz32">壹心保代桐乡分公司</div>
          </div>
        </div>
        <div class="compText">
          壹心首家旗舰店，开业首年保费超2000万，桐乡中介市场排名第一，团队快速裂变，由桐乡女企业家沈月清总监为领头人，在册团队142人，拥有高端客户服务体系，2019年至今创造新单保费3097万。
        </div>
      </div>
      <div class="middleItem">
        <div class="abilityImage">
          <img src="../assets/images/picture_21.png" alt="">
          <div class="ideaText">
            <div class="fz32">壹心保代诸暨分公司</div>
          </div>
        </div>
        <div class="compText">
          成立于2019年7月，目前在册92人，创始人8人，2年半创始人留存率100%。成立至今创造新单保费2893万，大团队长邵湄清总监从业20年，保险经验丰富，更是亲手打造了一支高绩效、高素质的优秀团队，人人MDRT的理念深植心中，2021年培养TOT1人，COT2人，MDRT4人，为诸暨中介市场头部力量。坚持用心服务客户的理念，让客户买的放心、安心。
        </div>
      </div>
    </div>

    <div class="teamDiv">
      <div class="abilityImage">
        <img src="../assets/images/picture_22.png" alt="">
        <!-- <div class="ideaText">
          <div class="fz32"></div>
        </div> -->
      </div>
      <div class="compText">
        成立于2018年底，目前在册197人，成立至今创造新单保费5315万。团队内绩优高手频出，致力于打造一支服务于高端客户的精英团队，团队成员由从业数十年的保险精英、乡绅、教师、企业家等高素质人才组成，短短三年跻身义乌保险市场前五名。
      </div>
    </div>

    <div class="middle">
      <div class="middleItem">
        <div class="abilityImage">
          <img src="../assets/images/picture_23.png" alt="">
          <div class="ideaText">
            <div class="fz32">壹心保代金华分公司</div>
          </div>
        </div>
        <div class="compText">
          金华分公司成立至今创造新单保费3461万，由传统保险服务模式与创新型事务所模式相结合，为客户建设全面终身保障，目前团队在册人力267人。
        </div>
      </div>
      <div class="middleItem">
        <div class="abilityImage">
          <img src="../assets/images/picture_24.png" alt="">
          <div class="ideaText">
            <div class="fz32">壹心保代杭州分公司</div>
          </div>
        </div>
        <div class="compText">
          职场位于和瑞科技园，2021年团队快速发展，引进两支同业优秀团队，以事务所特色经营模式，持续走专业化路线，成立至今创造新单保费598万。
        </div>
      </div>
      <div class="middleItem">
        <div class="abilityImage">
          <img src="../assets/images/picture_25.png" alt="">
          <div class="ideaText">
            <div class="fz32">壹心保代海宁分公司</div>
          </div>
        </div>
        <div class="compText">
          扎根地方，坚持保险下乡覆盖每一个老百姓的宗旨，致力于乡镇客户服务，团队成员覆盖同业优秀精英、退休干部等多层次，成立至今创造新单保费1434万。
        </div>
      </div>
      <div class="middleItem">
        <div class="abilityImage">
          <img src="../assets/images/picture_25-1.png" alt="">
          <div class="ideaText">
            <div class="fz32">壹心保代桐庐分公司</div>
          </div>
        </div>
        <div class="compText">
          作为2021年新生代机构，采用事务所精英模式，创造新单保费332万，目前团队人数近30人，团队成员从业经验丰富，具备专业化保险素养，2022年目标打造全人MDRT团队，为桐庐保险事业发展添砖加瓦。
        </div>
      </div>
    </div>

  </div>
</template>

<script>
  export default {
    name: 'abilityTeam',
    components: {},
    data() {
      return {
      }
    },
    computed: {},
    created() {},
    mounted() {},
    methods: {}
  };
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped>
  .abilityTeam {
    width: 1024px;
    margin: 0 auto;
    .teamDiv{
      margin-top: 30px;
      box-shadow: 0px 5px 30px 0px rgba(0, 0, 0, 0.1);
    }
    .compText{
      padding: 16px;
      margin-top: 0 !important;
    }
    .abilityImage {
      position: relative;
      font-size: 0;

      .ideaText {
        width: 100%;
        height: 80px;
        line-height: 80px;
        color: #ffffff;
        position: absolute;
        bottom: 0;
        padding-left: 40px;
        // background-color: rgba(0,0,0, 0.3);
        text-align: center;

        &>div:first-child {
          font-weight: 600;
        }
      }

      img {
        width: 100%;
      }
    }
    .middle {
      display: flex;
      flex-wrap: wrap;
      justify-content: space-between;
      .middleItem{
        width: 498px;
        box-shadow: 0px 5px 30px 0px rgba(0, 0, 0, 0.1);
        margin-top: 30px;
      }
    }
  }
</style>